import CryptoJS from 'crypto-js'
import { getStorage } from '@/utils/storage'

// base64加密
export function base64Encryption(data) {
  return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(data))
}
// base64解密
export function base64Decryption(data) {
  return CryptoJS.enc.Base64.parse(data).toString(CryptoJS.enc.Utf8)
}

export function aesAndBase64Encryption(data) {
  let key = getStorage('encryptKey')
  key = key ? base64Decryption(key) : ''
  try {
    return CryptoJS.AES.encrypt(JSON.stringify(data), CryptoJS.enc.Utf8.parse(key), {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    }).toString()
  } catch(error) {
    console.log(error, 'aesAndBase64Encryption')
    return null
  }
}

export function aesAndBase64Decryption(data) {
  let key = getStorage('encryptKey')
  key = key ? base64Decryption(key) : ''
  try {
    let str = CryptoJS.AES.decrypt(data, CryptoJS.enc.Utf8.parse(key), {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    }).toString(CryptoJS.enc.Utf8)
    return JSON.parse(str)
  } catch(error) {
    console.log(error, 'aesAndBase64Decryption')
    return null
  }
}